// extracted by mini-css-extract-plugin
export var container = "_3p-0";
export var containerTopRight = "_3p-1";